var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 0C13.9071 0 0 13.9071 0 31C0 48.0929 13.9071 62 31 62C48.0929 62 62 48.0929 62 31C62 13.9071 48.0929 0 31 0ZM31 4.76923C45.5152 4.76923 57.2308 16.4848 57.2308 31C57.2308 45.5152 45.5152 57.2308 31 57.2308C16.4848 57.2308 4.76923 45.5152 4.76923 31C4.76923 16.4848 16.4848 4.76923 31 4.76923ZM21.9862 18.5523L18.5523 21.9862L27.5757 31L18.5571 40.0138L21.9909 43.4477L31 34.4267L40.0138 43.4405L43.4477 40.0138L34.4267 31L43.4405 21.9862L40.0138 18.5523L31 27.5757L21.9862 18.5571V18.5523Z",
    fill: "#1B08A9",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmDelete);
export default __webpack_public_path__ + "static/media/confirmDelete.40c3cd04a9d80a5b9219b2e2106a074d.svg";
export { ForwardRef as ReactComponent };